import { render, staticRenderFns } from "./ShowRentalClothesProducts.vue?vue&type=template&id=606106ae&"
import script from "./ShowRentalClothesProducts.vue?vue&type=script&lang=js&"
export * from "./ShowRentalClothesProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports